import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { openModal } from '../actions/modal'
import { BREAKPOINT_EXTRA_SMALL, CX, MODAL_EDIT_SHORTCUTS } from '../constants'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import Heading from '../components/heading'
import Button from '../components/button'

class ShortcutsPage extends React.PureComponent {

  handleOnOpenEditShortcutsModal = () => {
    this.props.dispatch(openModal(MODAL_EDIT_SHORTCUTS))
  }

  render() {
    const { children, isXS } = this.props
    
    const title = 'Shortcuts'

    const containerClasses = CX({
      d: 1,
      w100PC: 1,
      maxW640PX: 1,
      mlAuto: 1,
      mrAuto: 1,
      px15: !isXS,
    })

    return (
      <DefaultLayout
        noSidebar
        noRightSidebar
        showBackBtn
        title={title}
        page='shortcuts'
        actions={[
          {
            icon: 'cog',
            onClick: this.handleOnOpenEditShortcutsModal,
          },
        ]}
      >
        <PageTitle path={title} />
        <div className={containerClasses}>
          {
            !isXS &&
            <div className={[_s.d, _s.mb15, _s.flexRow, _s.aiCenter].join(' ')}>
              <Heading size='h1'>{title}</Heading>
              <Button
                icon='cog'
                iconSize='18px'
                backgroundColor='tertiary'
                color='secondary'
                className={[_s.mlAuto, _s.aiCenter, _s.jcCenter, _s.h40PX, _s.w40PX].join(' ')}
                onClick={this.handleOnOpenEditShortcutsModal}
              />
            </div>
          }
          {children}
        </div>
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

ShortcutsPage.propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default connect(mapStateToProps)(ShortcutsPage)